"use client";

import { Play, ArrowLeft } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

export const VideoContentSection = () => {
    return (
        <div className="relative bg-gradient-to-br from-background/90 to-background/50 backdrop-blur-md rounded-3xl border border-border/30 p-8 overflow-hidden">
            {/* Animated Background */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-0 right-0 w-40 h-40 bg-primary/5 rounded-full blur-3xl animate-pulse" />
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary/5 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '1s' }} />
            </div>

            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Content Section */}
                <div className="flex flex-col justify-center">
                    <div className="space-y-6">
                        {/* Title with Gradient */}
                        <div className="space-y-2">
                            <span className="text-sm font-medium text-primary">آموزش و راهنما</span>
                            <h2 className="text-3xl font-bold bg-gradient-to-r from-primary via-primary/90 to-primary/80 bg-clip-text text-transparent">
                                راهنمای کامل خرید گیفت کارت
                            </h2>
                        </div>

                        {/* Description */}
                        <p className="text-muted-foreground leading-relaxed">
                            در این ویدیو به بررسی کامل نحوه خرید گیفت کارت، مزایا و معایب آن می‌پردازیم. 
                            همچنین نکات مهم و ترفندهای کاربردی برای خرید امن و مطمئن را آموزش می‌دهیم.
                        </p>

                        {/* Features List */}
                        <div className="grid grid-cols-2 gap-4">
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 rounded-full bg-primary" />
                                <span className="text-sm">آموزش قدم به قدم</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 rounded-full bg-primary" />
                                <span className="text-sm">نکات امنیتی</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 rounded-full bg-primary" />
                                <span className="text-sm">ترفندهای کاربردی</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 rounded-full bg-primary" />
                                <span className="text-sm">پشتیبانی 24/7</span>
                            </div>
                        </div>

                        {/* CTA Button */}
                        <Link 
                            href="/learn-more" 
                            className="group inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary/10 hover:bg-primary/20 transition-all duration-300 w-fit"
                        >
                            <span className="text-primary font-medium">بیشتر بدانید</span>
                            <ArrowLeft className="w-4 h-4 text-primary transition-transform duration-300 group-hover:-translate-x-1" />
                        </Link>
                    </div>
                </div>

                {/* Video Section */}
                <div className="relative group">
                    <div className="relative aspect-video rounded-2xl overflow-hidden">
                        {/* Video Thumbnail */}
                        <Image
                            src="/gallery/7.jpg"
                            alt="Video Thumbnail"
                            fill
                            className="object-cover transition-transform duration-700 group-hover:scale-110"
                        />
                        
                        {/* Overlay Gradient */}
                        <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/50 to-transparent" />
                        
                        {/* Play Button */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="relative">
                                {/* Animated Ring */}
                                <div className="absolute inset-0 rounded-full border-4 border-primary/20 animate-ping" />
                                <div className="absolute inset-0 rounded-full border-4 border-primary/20 animate-ping" style={{ animationDelay: '0.5s' }} />
                                
                                {/* Play Button */}
                                <button className="relative w-16 h-16 rounded-full bg-primary/90 hover:bg-primary transition-all duration-300 flex items-center justify-center group-hover:scale-110">
                                    <Play className="w-6 h-6 text-white" fill="currentColor" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}; 